// extracted by mini-css-extract-plugin
module.exports = {"scrollbarHide":"scrollbarHide--2njRG","scrollbar":"scrollbar--3Uoj2","scrollableContainer":"scrollableContainer--w9f4Y","scrollable":"scrollable--3cIfx"};